import loadable from '@loadable/component';

export const CourseProgress = loadable(/* #__LOADABLE__ */ () => import('./CourseProgress'));
